import React from "react";
import bind from "memoize-bind";

import EditButton from "lib/components/EditButton";

export default class PlaceholderValueWrapper extends React.PureComponent {
  constructor(...args) {
    super(...args);
    const { defaultPlaceholderVisible = true } = this.props;
    this.state = {
      placeholderVisible: defaultPlaceholderVisible,
    };
  }

  handleEditButtonClick(event) {
    event.preventDefault();
    this.setState({ placeholderVisible: false });
  }

  render() {
    const { placeholder, children } = this.props;
    const { placeholderVisible } = this.state;
    if (!placeholderVisible) {
      return children;
    } else {
      return (
        <span>
          <div className="ui input c-FakeInput">
            {placeholder}
            <EditButton onClick={bind(this.handleEditButtonClick, this)} />
          </div>
        </span>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/PlaceholderValueWrapper.jsx